export enum AutoCompleteTypeEnum {
    REQUEST = 'REQUEST',
    STATICLIST = 'STATICLIST'
}

export enum AutoCompleteThemeEnum {
    HEADER = 'HEADER',
    FOOTER = 'FOOTER',
    PAGE = 'PAGE',
    NOBUTTON = 'NOBUTTON',
    FILTER = 'FILTER'
}

export enum AutoCompleteRequestSourcesEnum {
    // Product Page Names
    // Product Selector Page Names
    // Content Page Titles of site
    // Substance Names
    SP = 'sp',
    // Substance Names
    // Substance Synonyms
    V = 'v'
}

export enum AutoCompleteKeyboardEnum {
    ENTER = 13,
    ESCAPE = 27,
    TAB = 9
}
